import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/make-booking/$id/')({
  beforeLoad: ({ params }) => {
    return redirect({
      replace: true,
      to: '/make-booking/$id/trip-details',
      params: { id: params.id },
    })
  },
})
